module.exports = __webpack_public_path__ + "static/media/Doan_Ngoc_Khanh.c9994841.jpg";